import { Grid2 as Grid } from '@mui/material';
import { PageTitle, useModalContext } from '@vxui/components';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { hasAdminRole, useGetAuthQuery } from '../../services';
import { useGetUsersQuery } from '../../services/users';
import { CreateUserModal, createUserModalId } from './CreateUserModal';
import { UsersTable } from './UsersTable';

export const UsersPage = () => {
  const { t } = useTranslation();

  const { data: me } = useGetAuthQuery();
  const { data: users = [], isLoading } = useGetUsersQuery();

  const { showModal, hideModal } = useModalContext();

  const closeCreateModal = useCallback(() => hideModal(createUserModalId), [hideModal]);
  const openCreateModal = useCallback(
    () => showModal(createUserModalId, <CreateUserModal onClose={closeCreateModal} />),
    [closeCreateModal, showModal],
  );

  const isAdmin = useMemo(() => hasAdminRole(me), [me]);

  return (
    <Grid container gap="20px">
      <Grid size={12}>
        <PageTitle
          title={t('navigation.users')}
          actionButton={
            isAdmin
              ? {
                  label: t('button.new'),
                  onClick: openCreateModal,
                }
              : undefined
          }
        />
      </Grid>
      <Grid size={12}>
        <UsersTable data={users} progressPending={isLoading} />
      </Grid>
    </Grid>
  );
};
